import * as React from "react";
import ReactDOM from "react-dom";
import OfferPrice from "../offerPrice/offerPrice.js";
export function PriceListInTab(props) {
    return ReactDOM.createPortal(React.createElement("div", { className: "description-container" },
        React.createElement("div", { className: "description-closing-container" },
            React.createElement("div", { className: "description-closing", onClick: props.onExit }, "\u2716")),
        props.categories.map((category, index) => (React.createElement("div", { key: index },
            React.createElement("h3", null, category.name),
            category.offers.map((offer, index) => (React.createElement(OfferPrice, { offer: offer, key: index }))))))), document.querySelector("#consent-description-container"));
}
